import script from "./moduleSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./moduleSetup.vue?vue&type=script&setup=true&lang=js"

import "./moduleSetup.vue?vue&type=style&index=0&id=0ebe7884&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ebe7884"]])

export default __exports__